import React, { useEffect, useRef } from "react";
import classes from "./TopThree.module.css";
import Container from "../../UI/Container/Container";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import image from "../../../assets/images/community-top--resized.jpg";

const TopThree = (props) => {
  gsap.registerPlugin(ScrollTrigger);

  const contentRef = useRef(null);
  const itemOneRef = useRef(null);
  const itemTwoRef = useRef(null);
  const itemThreeRef = useRef(null);

  useEffect(() => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: contentRef.current,
        start: "top 75%",
      },
    });

    timeline.to(contentRef.current, {opacity:1, duration:1, ease: 'sine.out'})
    timeline.to(itemOneRef.current, {opacity:1, transform:'translateX(0)', duration:0.5, ease:'sine.out'})
    timeline.to(itemTwoRef.current, {opacity:1, transform:'translateX(0)', duration:0.5, ease:'sine.out'})
    timeline.to(itemThreeRef.current, {opacity:1, transform:'translateX(0)', duration:0.5, ease:'sine.out'})
    // 
  });

  return (
    <div className={classes.TopThree}>
      <img src={image} alt="" />
      <div className={classes.Overlay}>
        <Container>
          <div ref={contentRef} className={classes.Content}>
            <div className={classes.Column}>
              <h2>
                Top <strong>3</strong> Things
                <br />
                We
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="heart"
                  className="svg-inline--fa fa-heart fa-w-16"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
                  ></path>
                </svg>
                about Carlisle
              </h2>
            </div>
            <div className={classes.Column}>
              <ol>
                <li ref={itemOneRef}>
                  Oodles of <strong>restaurants</strong> within walking distance
                  of campus!
                </li>
                <li ref={itemTwoRef}>
                  Free community events like <strong>Ice Art Fest</strong> and{" "}
                  <strong>Harvest of the Arts.</strong>
                </li>
                <li ref={itemThreeRef}>
                  Great{" "}
                  <strong>
                    hiking, fishing, boating, skiing, go-karting, mini-golfing,
                    shopping
                  </strong>
                  &mdash;everything!
                </li>
              </ol>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default TopThree;
